import { useEffect, useRef } from 'react';
import { css, cx } from '@emotion/css';
import { useTheme } from '@tcc-online/react-theme-provider';
import { useSelector } from 'react-redux';
import { generatePath, Link, matchPath, useLocation } from 'react-router-dom';

import styles from './QuestionnaireTimer.module.scss';
import { QUESTIONNAIRE_PATH } from '../../constants/route.constants';
import { SurveyTimerSelectors } from '../../common/selectors/SurveyTimerSelectors';
import useTimer from '../../hooks/useTimer';
import AuthSelectors from '../../selectors/AuthSelectors';

export default function QuestionnaireTimer() {
    const [theme] = useTheme();
    const logged = AuthSelectors.useIsLogged();
    const currentTimerId = useSelector(SurveyTimerSelectors.getCurrentId);
    const currentTime = useSelector(SurveyTimerSelectors.getCurrentTime);
    const { time, stopTimer, startTimer, setTime } = useTimer(currentTime, -1);
    const location = useLocation();
    const match = matchPath(QUESTIONNAIRE_PATH, location.pathname);
    const lastTime = useRef(0);

    useEffect(() => {
        if (currentTimerId !== null && currentTimerId !== undefined && logged) {
            startTimer();
        } else {
            stopTimer();
        }
    }, [currentTimerId, logged]);

    useEffect(() => {
        const handleVisibilityChange = function () {
            if (document.visibilityState === 'visible') {
                const currentTime = new Date().getTime();

                setTime(
                    (prev) => prev - (currentTime - lastTime.current) * 0.001,
                );
                startTimer();
            } else {
                stopTimer();
                lastTime.current = new Date().getTime();
            }
        };
        document.addEventListener('visibilitychange', handleVisibilityChange);

        return () => {
            document.removeEventListener(
                'visibilitychange',
                handleVisibilityChange,
            );
        };
    }, []);

    if (
        currentTimerId === null ||
        currentTimerId === undefined ||
        match !== null ||
        !logged
    ) {
        return null;
    }

    const minutes = Math.floor(Math.floor(time) / 60);
    const seconds = Math.floor(time) % 60;

    return (
        <div
            className={cx(
                styles.timer,
                css({
                    background: theme.surfaceColor,
                    borderRadius: `0 0 ${theme.borderRadius}px ${theme.borderRadius}px`,
                }),
            )}
        >
            <div className={styles.time}>
                {Math.floor(time) > 0
                    ? `${minutes}:${seconds > 9 ? seconds : `0${seconds}`}`
                    : '0:00'}
            </div>
            <div className={css({ color: theme.primaryColor })}>
                <Link
                    to={generatePath(QUESTIONNAIRE_PATH, {
                        id: currentTimerId,
                    })}
                >
                    zpět na dotazník
                </Link>
            </div>
        </div>
    );
}
